/**
 * Assets oficiales de los círculos de pertenencia (§6.3).
 * URLs absolutas hospedadas en S3 — single source of truth para los 3
 * componentes que renderizan círculos (AgentAvatar, CirclesPanel, CircleChip).
 */
import type { CircleTier } from '../store/api/usersApi';

const BASE = 'https://imperium.s3.us-east-1.amazonaws.com/pallet_illustrations/new_brand/3.+Circulos+de+pertenencia';

export const CIRCLE_LOGO: Record<CircleTier, string> = {
  amber:    `${BASE}/1+-+CIRCULO+AMBAR+a.png`,
  gold:     `${BASE}/2+-+CIRCULO+dorado.png`,
  nova:     `${BASE}/3+-+CIRCULO+NOVA.png`,
  imperial: `${BASE}/4+-+CIRCULO+IMPERIAL.png`,
  rhodium:  `${BASE}/5+-+CIRCULO+IMPERIAL.png`,
};

export const CIRCLE_LABEL: Record<CircleTier, string> = {
  amber:    'Ámbar',
  gold:     'Dorado',
  nova:     'Nova',
  imperial: 'Imperial',
  rhodium:  'Rodio',
};

export const CIRCLE_COLOR: Record<CircleTier, string> = {
  amber:    '#FFA726',
  gold:     '#D8BF82',
  nova:     '#9C6FE0',
  imperial: '#5C6BC0',
  rhodium:  '#90A4AE',
};
